import { Pills } from '../components/Pill';
import { SectionHeader } from '../components/SectionHeader';
import { TerminalWindow } from '../components/TerminalWindow';
import { products } from '../data/products';
import styles from './Products.module.css';

export function Products() {
  return (
    <section id="products" className="band band--alt">
      <div className="container content">
        <SectionHeader
          prompt="$ apt list --installed seaxdev-*"
          title={<>Products &amp; work</>}
          intro="Software we build and run ourselves, plus design work for clients. All live in production today."
        />
        <div className={styles.grid}>
          {products.map((p) => (
            <TerminalWindow
              key={p.pkg}
              as="article"
              header={
                <div className={styles.bar}>
                  <span>{p.pkg}</span>
                  <span>{p.platform}</span>
                </div>
              }
              bodyClassName={styles.body}
            >
              <div className={styles.kicker}>{p.kicker}</div>
              <h3 className={styles.name}>{p.name}</h3>
              <p className="copy">{p.copy}</p>
              <Pills items={p.pills} small className={styles.pills} aria-label="Highlights" />
              <a
                href={p.url}
                target="_blank"
                rel="noopener"
                className={styles.link}
                aria-label={`${p.name} website (opens in a new tab)`}
              >
                → {p.linkLabel}
              </a>
            </TerminalWindow>
          ))}
        </div>
      </div>
    </section>
  );
}
